import type { IAtributo } from "interfaces/loja/atributosProduto";
import type {
  IVariacaoAtributoPayload,
  IVariacaoProdutoState,
} from "interfaces/loja/variacaoProduto";

/**
 * Retorna o label de exibição para um item de atributo da variação.
 * LISTA: label da opção; COR: valorCor ou label da opção encontrada.
 */
export function getLabelAtributoVariacao(
  payload: IVariacaoAtributoPayload,
  atributos: IAtributo[]
): string {
  const atr = atributos.find((a) => a.id === payload.atributoId);
  if (!atr) return String(payload.valorCor ?? payload.opcaoId ?? "—");
  if (payload.opcaoId != null) {
    const op = (atr.opcoes || []).find((o) => o.id === payload.opcaoId);
    return op?.label ?? String(payload.opcaoId);
  }
  if (payload.valorCor != null) {
    const op = (atr.opcoes || []).find(
      (o) => o.valor === payload.valorCor || o.label === payload.valorCor
    );
    return op?.label ?? payload.valorCor;
  }
  return "—";
}

/**
 * Resposta da API pode vir com atributos aninhados (atributo/opcao/valorCor).
 * Normaliza para IVariacaoProdutoState.
 */
export function normalizarVariacoesDaApi(variacoes: any[]): IVariacaoProdutoState[] {
  return (variacoes || []).map((v) => {
    const atributos: IVariacaoAtributoPayload[] = (v.atributos || []).map(
      (a: any) => {
        const atributoId = a.atributo?.id ?? a.atributoId;
        // LISTA: API devolve opcao.id; payload envia opcaoId
        if (a.opcao?.id != null) {
          return { atributoId, opcaoId: a.opcao.id };
        }
        if (a.opcaoId != null) {
          return { atributoId, opcaoId: a.opcaoId };
        }
        // COR: API devolve valorCor
        if (a.valorCor != null) {
          return { atributoId, valorCor: a.valorCor };
        }
        return { atributoId };
      }
    );
    const custoRaw = v.precoCusto;
    const precoCustoNorm =
      custoRaw != null && custoRaw !== ""
        ? Number(custoRaw)
        : null;

    return {
      id: v.id,
      sku: v.sku ?? "",
      codigoBarras: v.codigoBarras ?? v.codigo_barras ?? "",
      preco: Number(v.preco) || 0,
      precoOriginal: Number(v.precoOriginal) || 0,
      precoCusto:
        precoCustoNorm != null && Number.isFinite(precoCustoNorm)
          ? precoCustoNorm
          : null,
      estoque: Number(v.estoque) || 0,
      emEstoque: Boolean(v.emEstoque !== false),
      isPadrao: Boolean(v.isPadrao),
      atributos,
    };
  });
}
